<template>

  <div style="max-height: 300px; overflow-y: auto;">

    <v-list dense>
      <v-list-item v-for="(loc, i) in locations" :key="i">
        <v-list-item-content class="my-0 py-0">
          <v-list-item-title>
            <v-checkbox hide-details
                        :ripple="false"
                        class="pt-0 mt-0"
                        v-model="selected"
                        :value="loc"
                        :label="loc.text"
            ></v-checkbox>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

<!--    <v-menu class="" offset-y max-height="300" dense>-->
<!--      <template v-slot:activator="{ on }">-->
<!--        <v-btn text v-on="on" small>-->
<!--          All Locations-->
<!--          <v-icon right>mdi-menu-down</v-icon>-->
<!--        </v-btn>-->
<!--      </template>-->
<!--      <v-list dense>-->
<!--        <v-list-item v-for="(loc, i) in locations" :key="i">-->
<!--          <v-list-item-content class="my-0 py-0">-->
<!--            <v-list-item-title>-->
<!--              <v-checkbox hide-details-->
<!--                          :ripple="false"-->
<!--                          class="pt-0 mt-0"-->
<!--                          v-model="selected"-->
<!--                          :value="loc"-->
<!--                          :label="loc.text"-->
<!--              ></v-checkbox>-->
<!--            </v-list-item-title>-->
<!--          </v-list-item-content>-->
<!--        </v-list-item>-->
<!--      </v-list>-->
<!--    </v-menu>-->

    <!--    <v-autocomplete-->
    <!--      v-model="selected"-->
    <!--      :items="locations"-->
    <!--      @change="handleChange"-->
    <!--      item-text="text"-->
    <!--      item-value="value"-->
    <!--      return-object-->
    <!--      dense-->
    <!--      multiple-->
    <!--    ></v-autocomplete>-->

    <v-card>

      <v-card-title
        class="subtitle-2 mt-5 font-weight-bold" v-if="selected.length">Selected Locations</v-card-title>

      <v-divider class="mt-4"></v-divider>

      <v-list dense>
        <v-list-item v-for="(loc, i) in selected" :key="i">
          <v-list-item-content>
            <v-list-item-title>
              {{loc.text}}
            </v-list-item-title>
            <v-divider class="mt-4"></v-divider>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-card>

  </div>

</template>

<script>

export default {

  name: 'FilterWidget_Locations',

  props: {},

  data() {
    return {
      selected: [],
    };
  },

  mounted() {
    this.$store.commit('SET_LOCATIONS', this.selected);
  },

  watch: {
    selected() {
      this.handleChange(this.selected);
    },
  },

  computed: {
    locations() {
      return this.$store.getters.locationsFiltered;
    },
  },

  methods: {

    handleChange(selectedLocations) {
      console.log(selectedLocations);
      if (selectedLocations && selectedLocations.length) {
        this.$store.commit('SET_LOCATIONS', selectedLocations);
      }
    },

  },

};
</script>
